"use client";
import * as React from "react";
const SvgFavoriteBorderRound = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 15", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M14.13 1.29A4.66 4.66 0 0 0 8 2.16a4.65 4.65 0 0 0-6.12-.87A4.3 4.3 0 0 0 0 4.69c-.1 3.08 2.64 5.55 6.84 9.33l.08.07a1.6 1.6 0 0 0 2.15 0l.09-.09c4.2-3.77 6.94-6.24 6.84-9.32a4.3 4.3 0 0 0-1.87-3.4M8.08 12.85l-.08.08-.08-.08C4.12 9.42 1.6 7.16 1.6 4.86c0-1.58 1.2-2.77 2.8-2.77 1.23 0 2.43.78 2.86 1.87h1.5a3.1 3.1 0 0 1 2.84-1.87c1.6 0 2.8 1.19 2.8 2.77 0 2.3-2.51 4.56-6.32 7.98" }));
export {
  SvgFavoriteBorderRound as default
};
